import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import WhyChoose from '../components/WhyChoose';
import Stats from '../components/Stats';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';

const Home = () => {
    return (
        <>
            <Hero />
            <About />
            <Services />
            <WhyChoose />
            <Stats />
            <Reviews />
            <Contact />
        </>
    );
};

export default Home;